import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { OrgType } from "./DialogOrgTable";
import WaveForm_org from "../../../component/common/waveSurfer/WaveForm_org.js";
import api from "../../../../API";
import OrgRejectRsnDialog from "./OrgRejectRsnDialog";
import PhotoIcon from '@mui/icons-material/Photo';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from "react-redux";
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import ReplayIcon from '@mui/icons-material/Replay';
import _debounce from 'lodash/debounce';
import OrgDelayRsnDialog from "./OrgDelayRsnDialog";
import OrgReuploadRsnDialog from "./OrgReuploadRsnDialog";


interface userDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: OrgType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<OrgType>>;
  getOrgList: any;
  p_order:any;
  p_isp_yn:any;
  p_vn_yn:any;
  p_worker:any;
}

const initailData: OrgType = {
  idx: -1,
  gub_ki: "",
  gub_ns: "",
  gub_subns: "",
  speaker1: "",
  speaker2: "",
  rec_ymd: "",
  seq: "",
  col_pk: "",

  upload_email: "",
  upload_name: "",

  file_dir: "",
  file_name_vn: "",
  file_name_vv: "",
  file_name_stt: "",

  rec_len: 0,
  rec_dev: "",

  spk1_num: 0,
  spk2_num: 0,
  spk_place: "",

  nd_place: "",
  rec_stime: "",
  max_db: 0,
  qat_num: 0,
  dlg_type: "",
  did: "",
  file_con_stt: "",
  isp_yn: "",
  isp_email: "",
  isp_name: "",
  isp_date: "",
  ins_date: "",

  reject_rsn: "",
};

export interface SpeakerType {
  id: string;
  gender: string;
  agegroup: string;
}

const initailSpeaker: SpeakerType = {
  id: "",
  gender: "",
  agegroup: ""
}

interface NvConScriptType{
  seq: number;
  mgm_con_pk: string;
  stc_con: string;
  con_type: string;
  con_info: string;
  qa_flag: string;
  sid: string;
  did: string;
  gub_ns: string;
  gub_subns: string;
}

interface NvSttSrt{
  idx: number;
  mgm_pk: string;
  seq: number;
  col_pk: string;
  start_time: string;
  end_time: string;
  speaker: string;
  stt_con: string;
  speak_time: number;
  spk_gub: string;
  asr_qtxt: string;
  wer: number;
  sid: string;
}

interface KiDoc{
  did: string;
  did_lpad: string;
  gub_ki: string;
  gub_kinm: string;
  gub_subnm: string;
  ki_stc: KiStc[];
  title: string;
  url: string;
  use_yn: string;
}

interface KiStc{
  did: string;
  keyword: string;
  sid: string;
  stext: string;
  title_sub: string;
  tkn_num: number;
}

const OrgDetailDialog = (props: userDetailProps) => {
  // console.log("props", props);

  const [data, setData] = useState<OrgType>(initailData);

  const [open, setOpen] = useState<boolean>(true);

  const [auths, setAuths] = useState([]);
  const [selectedAuth, setSelectedAuth] = useState('');

  const [rejectPageOpen , setRejectPageOpen] = useState<boolean>(false);

  const [delayPageOpen , setDelayPageOpen] = useState<boolean>(false);

  const [reuploadPageOpen , setReuploadPageOpen] = useState<boolean>(false);

  const [dialogSize , setDialogSize] = useState(false)

  const [sampleFileName, setSampleFileName] = useState("")

  const [photoUrl , setPhotoUrl] = useState("")

  const [srt , setSrt] = useState("")

  const auth = useSelector((state:any)=> state.userInfo.data)
  const isp_email = auth.user.email;


  const [speaker1, setSpeaker1] = useState<SpeakerType>(initailSpeaker);

  const [speaker2, setSpeaker2] = useState<SpeakerType>(initailSpeaker);

  const [con_script, setCon_script] = useState<NvConScriptType[]>([]);

  const [nvSttSrt, setNvSttSrt] = useState<NvSttSrt[]>([]);
  
  // stt 수정 함수
  const handleRemoveRow = (seq:any) => {
    // const updatedSttsrt = con_script.filter((row:any) => row.seq !== seq);
    // setNvSttSrt(updatedSttsrt);
    setNvSttSrt((prevSttsrt) => {
      const removeIndex = prevSttsrt.findIndex((row) => row.seq === seq);
      const removedSeq = prevSttsrt[removeIndex].seq;
      // console.log('제거 seq :: ',removedSeq)

      // Create a new array excluding the item to be removed
      const updatedSttsrt = prevSttsrt.filter((row) => row.seq !== seq);

      // Adjust the 'seq' of the remaining items if necessary
      const updatedSeqSttsrt = updatedSttsrt.map((row) => {
        if (row.seq > removedSeq) {
          return { ...row, seq: row.seq - 1 };
        }
        return row;
      });

      // console.log('변경된 배열' , updatedSeqSttsrt)

      return updatedSeqSttsrt;
    });
  };

  const handleAddRow = (seq: any) => {
    setNvSttSrt((prevSttsrt: any) => {
      const addIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      const nexIndex = prevSttsrt.findIndex((row: any) => row.seq === seq+1);

      const addSeq = prevSttsrt[addIndex].seq + 1;
  
      const randomNumber = Math.random() * 100000; // 0부터 100000 사이의 랜덤 숫자 생성
      const roundedNumber = Math.round(randomNumber) / 100000; // 소수점 다섯 자리까지 반올림

      // console.log('roundedNumber', roundedNumber)

      // console.log('줄 추가의 end_time', prevSttsrt[addIndex].end_time)

      let p_speaker = ""
      if(addSeq%2 == 0){
        p_speaker = speaker2.id
      }else{
        p_speaker = speaker1.id
      }

      const newItem = {
        ...prevSttsrt[addIndex], // Copy all properties from the original item
        idx: prevSttsrt[addIndex].idx + 0.001 + roundedNumber,
        seq: addSeq,
        spk_gub: "N",
        sid: "",
        speaker: p_speaker,
        stt_con: "",
        start_time: prevSttsrt[addIndex].end_time,
        end_time: nexIndex !== -1 ? prevSttsrt[nexIndex].start_time : prevSttsrt[addIndex].end_time,
      };
  
      // Create a new array with the new item inserted at the specified index
      const addedSttsrt = [
        ...prevSttsrt.slice(0, addIndex + 1),
        newItem,
        ...prevSttsrt.slice(addIndex + 1),
      ];
  
      // Adjust the 'seq' of the remaining items after the insert index
      const updatedSeqSttsrt = addedSttsrt.map((row: any, index: number) => ({
        ...row,
        seq: index + 1,
      }));
  
      // console.log('변경된 배열', updatedSeqSttsrt);
      return updatedSeqSttsrt;
    });
  };

  const handleChangeQA = (qa:string,seq: any) => {

    console.log('체크' ,qa ,seq , (qa === 'Q') ,seq%2 , ((seq%2) != 0) )
    if((qa === 'A') && ((seq%2) != 0)){
      alert('참석자 1 은 답변을 설정할 수 없습니다.')
      return;
    }

    if((qa === 'Q') && ((seq%2) == 0)){
      alert('참석자 2 는 질문을 설정할 수 없습니다.')
      return;
    }

    setNvSttSrt((prevSttsrt: any) => {
      const updatedSttsrt = [...prevSttsrt];

      const preIndex = prevSttsrt.findIndex((row: any) => row.seq === seq-1);
      const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      if(qa === 'Q'){
        updatedSttsrt[rowIndex] = {
          ...updatedSttsrt[rowIndex],
          spk_gub: updatedSttsrt[rowIndex].spk_gub === "Q" ? "N" : "Q",
        };
      }else if(qa === 'A'){
        updatedSttsrt[rowIndex] = {
          ...updatedSttsrt[rowIndex],
          sid: updatedSttsrt[rowIndex].spk_gub === "A" ? "" : updatedSttsrt[rowIndex].sid,
          spk_gub: updatedSttsrt[rowIndex].spk_gub === "A" ? "N" : "A",
        };
      }
      
      // console.log('변경 ' , updatedSttsrt)

      return updatedSttsrt;
    });
  };

  const handleChangeSID = (p_sid:string,seq: any) => {

    setNvSttSrt((prevSttsrt: any) => {
      const updatedSttsrt = [...prevSttsrt];

      const preIndex = prevSttsrt.findIndex((row: any) => row.seq === seq-1);
      const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      // Modify the qa_flag value for the specific row
      // 질문 줄 sid 설정
      updatedSttsrt[preIndex] = {
        ...updatedSttsrt[preIndex],
        sid: p_sid
      };

      // 답변 줄 sid 설정
      updatedSttsrt[rowIndex] = {
        ...updatedSttsrt[rowIndex],
        sid: p_sid
      };
      
      return updatedSttsrt;
    });
  };

  const handleChangeTime = (value:string,type:string,seq: any) => {

    const numericValue = value.replace(/[^0-9]/g, ''); // 숫자만 추출

    if (numericValue.length > 9) {
      return; // 최대 9자리까지만 처리
    }

    let formattedTime = '';
    for (let i = 0; i < numericValue.length; i++) {
      if (i === 2 || i === 4) {
        formattedTime += `:${numericValue[i]}`;
      } else if (i === 6) {
        formattedTime += `,${numericValue[i]}`;
      } else {
        formattedTime += numericValue[i];
      }
    }
    

    // console.log('바뀔 Time 값?' , formattedTime)

    setNvSttSrt((prevSttsrt: any) => {
      const updatedSttsrt = [...prevSttsrt];

      const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

      // Modify the qa_flag value for the specific row
      if(type === "start_time"){
        updatedSttsrt[rowIndex] = {
          ...updatedSttsrt[rowIndex],
          start_time: formattedTime
        };
      }else if(type === "end_time"){
        updatedSttsrt[rowIndex] = {
          ...updatedSttsrt[rowIndex],
          end_time: formattedTime
        };
      }
      
      
      // console.log('변경 con_script stc_con' ,seq, updatedSttsrt)

      return updatedSttsrt;
    });
  };

  // const handleChangeStt_con = (p_stt_con:string,seq: any) => {
  //     setNvSttSrt((prevSttsrt: any) => {
  //       const updatedSttsrt = [...prevSttsrt];

  //       const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === seq);

  //       // Modify the qa_flag value for the specific row
  //       updatedSttsrt[rowIndex] = {
  //         ...updatedSttsrt[rowIndex],
  //         stt_con: p_stt_con
  //       };
        
  //       // console.log('변경 STT_CON' ,seq, updatedSttsrt)

  //       return updatedSttsrt;
  //     });
  // };
  const debouncedHandleChangeStt_con = _debounce((p_stt_con, seq) => {
    setNvSttSrt((prevSttsrt) => {
      const updatedSttsrt = [...prevSttsrt];
      const rowIndex = prevSttsrt.findIndex((row) => row.seq === seq);

      // Modify the qa_flag value for the specific row
      updatedSttsrt[rowIndex] = {
        ...updatedSttsrt[rowIndex],
        stt_con: p_stt_con,
      };

      return updatedSttsrt;
    });
  }, 300); // 300ms 후에 실행됩니다.

  const handleChangeStt_con = (p_stt_con:string, seq:number) => {
    // debounce된 핸들러를 호출합니다.
    debouncedHandleChangeStt_con(p_stt_con, seq);
  };

  // stt 수정 함수

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    // console.log('result.data.data',result.data.data)
  };

  const getSpeakerInfo = async (speaker1:string,speaker2:string) => {
   await api.get("/getSpeakerInfo",{params:{speaker1:speaker1,speaker2:speaker2}})
    .then((res:any) => {
      // console.log('발화자 정보',res.data.datas)
      const speakerInfo = res.data.datas
      
      console.log('발화자1 정보',speakerInfo.filter((speaker:any) => speaker.main_yn === 'Y')[0])
      console.log('발화자2 정보',speakerInfo.filter((speaker:any) => speaker.main_yn === 'N')[0])

      setSpeaker1(speakerInfo.filter((speaker:any) => speaker.main_yn === 'Y')[0])
      setSpeaker2(speakerInfo.filter((speaker:any) => speaker.main_yn === 'N')[0])
      })

  };

  const getNvConScriptSttsrt = async (col_pk:string) => {
    await api.get("/nvConScriptSttSrt",{params:{mgm_con_pk:col_pk}})
    .then((res:any) => {setCon_script(res.data.datas); console.log('con_script', res.data.datas)})
  }

  const getNvSttSrt = async (col_pk:string) => {
    await api.get("/getNvSttSrt",{params:{col_pk:col_pk}})
    .then((res:any) => setNvSttSrt(res.data.datas))
  }

  const [first_pro , setFirst_pro] = useState<boolean>(false);

  if(con_script.length > 0 && nvSttSrt.length > 0 && !first_pro) {
    // console.log('con_script map 돌려야함',con_script)
    con_script.map((con:NvConScriptType) => {
      // console.log('콘 ???? ', con_script)
      if(con.qa_flag === "Q" || con.qa_flag === "A"){
        setNvSttSrt((prevSttsrt: any) => {
          const updatedSttsrt = [...prevSttsrt];
    
          const preIndex = prevSttsrt.findIndex((row: any) => row.seq === (con.seq-1));
          const rowIndex = prevSttsrt.findIndex((row: any) => row.seq === con.seq);

          // console.log('rowIndex', rowIndex)

          if(rowIndex !== -1){
            if(con.qa_flag === 'Q'){
              updatedSttsrt[rowIndex] = {
                ...updatedSttsrt[rowIndex],
                spk_gub: "Q",
              };
            }else if(con.qa_flag === 'A'){
              updatedSttsrt[preIndex] = {
                ...updatedSttsrt[preIndex],
                sid: con.sid,
              };

              updatedSttsrt[rowIndex] = {
                ...updatedSttsrt[rowIndex],
                sid: con.sid,
                spk_gub: "A",
              };
            }
            console.log('기본세팅변경 ' , updatedSttsrt)
          }

          return updatedSttsrt;
    
          
        });
      }

      
    });

    setFirst_pro(true)
    
  }


  const nvSttSrtConfirm = async () => {

    // const base_data = nvSttSrt[0]

    const formData = new FormData();

    formData.append("email", isp_email);
    formData.append("col_pk", data.col_pk);
    formData.append("isp_email", isp_email);
    formData.append("isp_yn", "Y");

    formData.append("speaker1", speaker1.id);
    formData.append("speaker2", speaker2.id);

    console.log('수정 SRT' , nvSttSrt)

    formData.append("nvSttSrt", JSON.stringify(nvSttSrt));
    
    // return ;

    await api.post("/nvSttSrtConfirm",formData)
    .then((res:any) => {alert('스크립트 검사완료 처리 되었습니다.'); props.getOrgList(props.p_order,props.p_isp_yn,props.p_vn_yn,props.p_worker); setOpen(false); props.setDialogOpen(false); })
    .catch((error:any) => {console.log('error',error);alert(error.response.data.error);})

  }

  // const sampleReject = () => {
  //   setRejectPageOpen(false);
  //   setOpen(false);
  //   props.setDialogOpen(false); 
  //   props.getOrgList();
  // }

  const stopWaveform = () =>{
    props.setDialogOpen(false); 
    props.setRowDetail(initailData);
  }

  const [replay, setReplay] = useState('');

  const replayWave = (time:string) =>{
    // console.log('재생 시간 초??' , time)  
    setReplay(time)
  }

  const [waveSec, setWaveSec] = useState('');

  // const [ingTime, setIngTime] = useState('');

  // console.log('재생 시간 초??' , waveSec)

  // console.log('재생 시간 초??' , waveSec)


  // useEffect(() => {
    
  //   setIngTime(waveSec);


  // }, [waveSec]);

  const [kiDoc, setKiDoc] = useState<KiDoc[]>([]);

  const [kiStc, setKiStc] = useState<KiStc[]>([]);

  const getKiDoc = async (did:string) => {
    // console.log('did 다시 인트형으로',parseInt(did, 10),"/getKiDoc?did="+parseInt(did, 10))
    var result = await api.get("/getKiDoc?did="+parseInt(did, 10))
    .then(response => {
      // console.log('getKiDoc 정보', response.data.datas)
      const res = response.data.datas
      if(res.length > 0){
        // console.log('ki_stc 정보 ?? ' , res[0].ki_stc)
        setKiStc(res[0].ki_stc)
      }
      setKiDoc(response.data.datas)
    });


  }

  const [stopUpdate , setStopUpdate] = useState<boolean>(false);

  useEffect(() => {
    getAuths();
    // console.log("sampleDetailDialog");
    if (props.rowDetail != null){
      setData(props.rowDetail);
      // if(props.rowDetail.state)
      getSpeakerInfo(props.rowDetail.speaker1, props.rowDetail.speaker2)
      console.log('로우 디테일',props.rowDetail)
      if((props.rowDetail.file_name_vn.length == 42) && (props.rowDetail.isp_yn === 'Y')){
        console.log('음성작업 OK',props.rowDetail.file_name_vn.length)
        setStopUpdate(true)
      }
      // setStopupdate(props.rowDetail.file_name_vn)

      if(props.rowDetail.isp_yn == 'Y'){
        setFirst_pro(true)
      }
      getKiDoc(props.rowDetail.did)
      getNvConScriptSttsrt(props.rowDetail.col_pk)
      getNvSttSrt(props.rowDetail.col_pk)

      // setNvSttSrt_default_spk_gub_sid()
      // if(props.rowDetail.isp_yn === '문서제출'){
      //   getUserInfo(props.rowDetail.email)
      // }
    }
    
  }, [props.rowDetail]);

  return (
    <Box>
      <Dialog fullScreen open={true} fullWidth={true}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>수집 데이터 확인</Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>
          <Box>
            <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
  
              <Box display="flex" justifyContent="center">

                {/* wavform */}
                <Box>
                  {data.idx !== -1 ? 
                  <React.Fragment>
                    <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>Audio 플레이</Box>
                    {/* <Waveform url={"http://121.135.229.125/api/orgAudioInfo?idx="+data.idx} open={open} stopWaveform={stopWaveform} /> */}
                    {/* <WaveForm_org url={"https://localhost:9680/orgAudioInfo?idx="+data.idx} open={open} stopWaveform={stopWaveform} setWaveSec={setWaveSec} replay={replay} setReplay={setReplay} /> */}
                    <WaveForm_org url={"http://121.135.229.125/api/orgAudioInfo?idx="+data.idx} open={open} stopWaveform={stopWaveform} setWaveSec={setWaveSec} replay={replay} setReplay={setReplay} />
                  </React.Fragment>
                  :""}
                </Box>
                {/* wavform */}

                

                <Box display="flex" sx={{marginLeft: "100px"}}>
                  <Box sx={{width:"100%"}}>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>이메일(수집)</Box>
                      <TextField
                        id="upload_email"
                        value={data.upload_email}
                        type="email"
                        variant="standard"
                        sx={{fontSize:"14px", height:"20px", marginRight:"34px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: { height:"20px", fontSize:"14px"},
                        }}
                      />
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"90px"}}>이름(수집)</Box>
                      <TextField
                        id="upload_name"
                        value={data.upload_name}
                        variant="standard"
                        sx={{marginLeft:"8px", height:"20px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: { height:"20px", fontSize:"14px"},
                        }}
                      />
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>음성파일</Box>
                      <TextField
                        id="file_name_vv"
                        value={data.file_name_vv}
                        variant="standard"
                        sx={{width:"80%", height:"20px", marginLeft:"8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: { height:"20px", fontSize:"14px"},
                        }}
                      />
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>화자1</Box>
                      {speaker1 && 
                      <Box display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>ID</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker1.id}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>성별</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"1px solid #fff", padding: "2px 6px 2px 6px", borderRadius:"4px",
                                color:"#fff", backgroundColor:(speaker1.gender === "남성" ? "#498ad5" : "#d549a6")}}>
                          {speaker1.gender}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>나이대</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker1.agegroup}
                        </Box>
                      </Box>
                      }
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>화자2</Box>
                      {speaker2 && 
                      <Box display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>ID</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker2.id}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>성별</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"1px solid #fff", padding: "2px 6px 2px 6px", borderRadius:"4px",
                                color:"#fff", backgroundColor:(speaker2.gender === "남성" ? "#498ad5" : "#d549a6")}}>
                          {speaker2.gender}
                        </Box>
                        <Box sx={{fontSize:"14px",fontWeight:700}}>나이대</Box>
                        <Box sx={{fontSize:"14px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {speaker2.agegroup}
                        </Box>
                      </Box>
                      }
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>업로드시간</Box>
                      <TextField
                        id="ins_date"
                        value={data.ins_date}
                        variant="standard"
                        sx={{marginLeft:"8px", height:"20px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                        InputProps={{
                          readOnly: true,
                          style: { height:"20px", fontSize:"14px"},
                        }}
                      />
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>검수결과</Box>
                      <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          backgroundColor: (data.isp_yn === "N" ? "red" : (data.isp_yn === "Y" ? "#498ad5" : "#27cc2f")), color:"#fff"
                      }}>
                        {(data.isp_yn === "N" ? "부적합" : (data.isp_yn === "0" ? "작업전" : (data.isp_yn === "D" ? "보류" : (data.isp_yn === "Y" ? "적합":"상태이상"))))}
                      </Box>
                    </Box>
                    <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      {((data.reject_rsn !== "" && data.reject_rsn !== "None")) ? <Box>부적합사유: <b style={{color:"red"}}>{data.reject_rsn}</b></Box> : ""}
                    </Box>
                    
                  </Box>
                </Box>
              {rejectPageOpen ? <OrgRejectRsnDialog email={data.upload_email} col_pk={data.col_pk} getOrgList={props.getOrgList} p_order={props.p_order} p_isp_yn={props.p_isp_yn} p_vn_yn={props.p_vn_yn} p_worker={props.p_worker} setRejectPageOpen={setRejectPageOpen} setOpen={setOpen} /> : <></>}
              {delayPageOpen ? <OrgDelayRsnDialog email={data.upload_email} col_pk={data.col_pk} getOrgList={props.getOrgList} p_order={props.p_order} p_isp_yn={props.p_isp_yn} p_vn_yn={props.p_vn_yn} p_worker={props.p_worker}  setDelayPageOpen={setDelayPageOpen} setOpen={setOpen} /> : <></>}
              {reuploadPageOpen ? <OrgReuploadRsnDialog email={data.upload_email} col_pk={data.col_pk} getOrgList={props.getOrgList} p_order={props.p_order} p_isp_yn={props.p_isp_yn} p_vn_yn={props.p_vn_yn} p_worker={props.p_worker}  setReuploadPageOpen={setReuploadPageOpen} setOpen={setOpen} /> : <></>}
              {/* </form> */}
              </Box>

              <Box sx={{border: "3px solid #3e36a5", margin: "auto", width:"1470px"}}>
                {kiDoc.length > 0 &&
                  kiDoc.map((doc:KiDoc) =>

                  <Box key={doc.did}>
                    <Box sx={{display:"flex", justifyContent:"center", fontSize:"14px", height:"6px"}}>
                      <Box sx={{margin:"1px",marginRight:"24px"}}>문서ID : <b style={{color:"#498ad5"}}>{doc.did}</b></Box>
                      <Box sx={{margin:"1px",marginRight:"24px"}}>지식주제분류 : <b style={{color:"#498ad5"}}>{doc.gub_kinm} {doc.gub_subnm != "" ? <b> 세분류 : + {doc.gub_subnm}</b> : "" } </b></Box>
                      <Box sx={{margin:"1px"}}>사용여부 : {doc.use_yn}</Box>
                    </Box>
                    <Box display="flex" sx={{alignItems:"center", marginLeft:"4px"}}>
                      <Box sx={{height:"12px",fontSize:"14px",color:"#fff",marginRight:"12px",backgroundColor:"#498ad5",padding:"2px",borderRadius:"5px"}}>문장ID</Box>
                      <Box sx={{height:"12px",fontSize:"14px",color:"#fff",backgroundColor:"#498ad5",padding:"2px",borderRadius:"5px"}}>문장텍스트</Box>
                    </Box>
                    <Box sx={{margin:"2px", height:"88px", overflow:"auto"}}>
                    {doc.ki_stc.length > 0 && doc.ki_stc.map((stc:KiStc) =>
                      <Box key={stc.sid} display="flex" sx={{alignItems:"center",border:"2px solid #498ad5"}}>
                        <Box sx={{width:"44px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>{stc.sid}</Box>
                        <textarea defaultValue={stc.stext} style={{width:"1390px", height:"20px", fontSize:"11px", padding:"2px"}} />
                      </Box>
                    )}
                    </Box>

                  </Box>
                  )}
              </Box>
              <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #8bb5e4 70%)"}}>
                <Box sx={{fontSize:"14px", fontWeight:700,width:"90%"}}>기존 스크립트({con_script.length} 줄)</Box>
                <Box sx={{fontSize:"14px", fontWeight:700,width:"100%"}}>수집 SRT({nvSttSrt.length} 줄)</Box>
              </Box>
              

            </Box>

            {/* <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #8bb5e4 70%)"}}>
              <Box sx={{fontSize:"14px", fontWeight:700,width:"90%"}}>기존 스크립트({con_script.length} 줄)</Box>
              <Box sx={{fontSize:"14px", fontWeight:700,width:"100%"}}>수집 SRT({nvSttSrt.length} 줄)</Box>
            </Box> */}

            <Box sx={{height:"100%", overflow:"auto", background: "linear-gradient(to right, #e6e6e6 30%, #8bb5e4 70%)"}}>
              <Box display="flex" justifyContent="center" >

                <Paper sx={{padding:"4px", border:"3px solid #3e36a5"}}>
                  {/* <textarea readOnly defaultValue={srt} style={{width:"654px" , height:"654px"}}  /> */}
                  {con_script.length > 0 ? 
                    (
                      con_script.map((row:any,index:any)=>
                      // <Box key={row.idx} sx={{backgroundColor:(row.seq%2 == 0 ? "#dffffc":"#fff"), margin:"4px",borderBottom:"3px solid #3e36a5"}}>
                      <Box key={row.idx} sx={{backgroundColor:(row.seq%2 == 0 ? "#fff":"#fff"), margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{height:"58px"}}>
                            <Box sx={{display:"flex", alignItems:"center", height:"58px"}}>
                              <Box sx={{width:"34px",fontSize:"24px",fontWeight:700, textAlign: "center", margin: "1px"}}>{row.seq}</Box>
                              {/* <Box sx={{width:"50px", textAlign: "center"}}> */}
                                {/* <Checkbox sx={{height:"24px"}} checked={true} onClick={(e:anyw)=> {handleRemoveRow(row.seq)}}></Checkbox> */}
                                {/* <Box sx={{marginBottom:"2px"}}><Button sx={{minWidth:"20px",height:"20px",fontSize:"20px",fontWeight:600,padding:"0 !important",backgroundColor:"#fff",border:"2px solid #ff0000",color:"#ff0000"}} variant="contained" onClick={(e:any)=> {handleRemoveRow(row.seq)}}>-</Button></Box>
                                <Box sx={{marginBottom:"2px"}}><Button sx={{minWidth:"20px",height:"20px",fontSize:"20px",fontWeight:600,padding:"0 !important",backgroundColor:"#fff",border:"2px solid #2f9c34",color:"#2f9c34"}} variant="contained" onClick={(e:any)=> {handleAddRow(row.seq)}}>+</Button></Box> */}
                                
                              {/* </Box> */}
                              {/* <Checkbox defaultValue="true" onClick={(e:any)=>e.target.checked === true ? setConfirmRole(v.role) : setConfirmRole('')}></Checkbox> */}
                              <Box sx={{width:"82px", marginLeft:"4px"}}>
                                <Box sx={{marginTop:"2px"}}>{row.seq%2 == 0 ? "참석자 2": "참석자 1"}</Box>
                                <Box>
                                  {(row.seq%2 != 0) ?
                                    <Box sx={{display:"flex", alignItems:"center",height:"20px",margin:"2px"}}>
                                        <Box>질문:</Box>
                                        <Checkbox style={{ color: '#da33f0' }} checked={row.qa_flag == "Q" ? true:false} ></Checkbox>
                                    </Box>
                                    :
                                    <Box>
                                      <Box sx={{display:"flex", alignItems:"center",height:"20px",margin:"2px"}}>
                                        <Box>답변:</Box>
                                        {/* <Checkbox style={{ color: '#27cc2f' }} checked={row.qa_flag == "A" ? true:false} onClick={(e:any)=> handleChangeQA('A',row.seq)}></Checkbox> */}
                                      
                                        {row.qa_flag == "A" &&
                                          ((kiStc && kiStc.length !== 0) && 
                                          <FormControl style={{width:"34px", fontSize:"12px",marginLeft:"4px"}} >
                                            <Select id="scriptState" value={row.sid} sx={{width:"34px",height: "20px", border:"2px solid #498ad5", padding: "2px 0px 2px 4px", borderRadius:"4px", backgroundColor:"#d5ffd7"}}>
                                              <MenuItem dense value={''}>{''}</MenuItem>
                                              {kiStc.map((stc: any) => 
                                                <MenuItem dense key={stc.sid} value={stc.sid}>{stc.sid}</MenuItem>
                                              )}
                                            </Select>
                                          </FormControl>
                                          )
                                        }
                                      </Box>
                                    </Box>
                                  }
                                </Box>
                              </Box>
                              <Box sx={{marginLeft:"6px"}}>
                                <Box sx={{display:"flex", alignItems:"center"}}>
                                  
                                  {/* {row.sid !== "" ? <Box sx={{fontSize:"14px", fontWeight:600, marginLeft:"8px", color:"red"}}>문장ID : {row.sid}</Box>: ""} */}
                                </Box>
                                <Box><textarea readOnly={true} defaultValue={row.stc_con} style={{width:"500px",minHeight:"40px", fontSize:"12px", fontWeight:600,padding:"2px", backgroundColor:((row.qa_flag === "" || row.qa_flag === "None") ? "#fff": (row.qa_flag === "Q" ? "#fbf4dd":"#d5ffd7"))}}  /></Box>
                              </Box>
                            </Box>
                            
                          </Box>
                        </Box>
                      </Box>

                      )
                    ):""
                  }
                </Paper>

                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", marginLeft:"40px"}}>
                  {/* <textarea readOnly defaultValue={srt} style={{width:"654px" , height:"654px"}}  /> */}
                  {nvSttSrt.length > 0 ? 
                    (
                      nvSttSrt.map((row:any,index:any)=>
                      // <Box key={row.idx} sx={{backgroundColor:(row.seq%2 == 0 ? "#dffffc":"#fff"), margin:"4px",borderBottom:"3px solid #3e36a5"}}>
                      <Box key={row.idx} sx={{ margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{height:"58px",}}>
                            <Box sx={{display:"flex", alignItems:"center", height:"58px"}}>
                                {
                                    (waveSec >= row.start_time && waveSec <= row.end_time)
                                      ? <Box sx={{width:"34px",fontSize:"24px",fontWeight:700, textAlign: "center", margin: "1px", marginTop:"4px", backgroundColor: "#2cc382", color: "#fff", alignSelf: "center",borderRadius: "50%"}}><MusicNoteIcon/></Box>  // 배경색이 초록색일 경우
                                      : <Box sx={{width:"34px",fontSize:"24px",fontWeight:700, textAlign: "center", margin: "1px"}}>
                                            {row.seq}
                                        </Box>  // 배경색이 원래 색일 경우
                                }
                              {/* <Box sx={{width:"34px",fontSize:"24px",fontWeight:700, textAlign: "center", margin: "1px"}}>
                                  {row.seq}
                              </Box> */}
                              
                              <Box sx={{width:"44px", textAlign: "center"}}>
                                {/* <Checkbox sx={{height:"24px"}} checked={true} onClick={(e:any)=> {handleRemoveRow(row.seq)}}></Checkbox> */}
                                <Box sx={{marginBottom:"2px"}}><Button sx={{minWidth:"20px",height:"18px",fontSize:"20px",fontWeight:600,padding:"0 !important",backgroundColor:"#fff",border:"2px solid #ff0000",color:"#ff0000"}} variant="contained" onClick={(e:any)=> {handleRemoveRow(row.seq)}}>-</Button></Box>
                                <Box sx={{marginBottom:"2px"}}><Button sx={{minWidth:"20px",height:"18px",fontSize:"20px",fontWeight:600,padding:"0 !important",backgroundColor:"#fff",border:"2px solid #2f9c34",color:"#2f9c34"}} variant="contained" onClick={(e:any)=> {handleAddRow(row.seq)}}>+</Button></Box>
                              </Box>
                              {/* <Checkbox defaultValue="true" onClick={(e:any)=>e.target.checked === true ? setConfirmRole(v.role) : setConfirmRole('')}></Checkbox> */}
                              <Box sx={{width:"116px"}}>

                                {/* 화자 정보 */}
                                <Box sx={{display:"flex", alignItems:"center"}}>
                                  <Box sx={{fontSize:"12px", display:"flex", alignItems:"center"}}>{row.speaker}{row.speaker === speaker1.id ? 
                                    <Box sx={{fontSize:"12px", marginLeft:"8px",marginRight:"12px",marginTop:"2px", border:"1px solid #fff", padding: "2px 6px 2px 6px", borderRadius:"4px",
                                            color:"#fff", backgroundColor:(speaker1.gender === "남성" ? "#498ad5" : "#d549a6")}}>
                                      {speaker1.gender}
                                    </Box>
                                    : 
                                    <Box sx={{fontSize:"12px", marginLeft:"8px",marginRight:"12px",marginTop:"2px", border:"1px solid #fff", padding: "2px 6px 2px 6px", borderRadius:"4px",
                                            color:"#fff", backgroundColor:(speaker2.gender === "남성" ? "#498ad5" : "#d549a6")}}>
                                      {speaker2.gender}
                                    </Box>
                                  }</Box>
                                  {/* {row.sid !== "" ? <Box sx={{fontSize:"14px", fontWeight:600, marginLeft:"8px", color:"red"}}>문장ID : {row.sid}</Box>: ""} */}
                                </Box>
                                {/* 화자 정보 */}


                                {(row.seq%2 != 0) ?
                                  <Box sx={{display:"flex", alignItems:"center",height:"20px",margin:"2px"}}>
                                      <Box>질문:</Box>
                                      <Checkbox style={{ color: '#da33f0' }} checked={row.spk_gub == "Q" ? true:false} onClick={(e:any)=> handleChangeQA('Q',row.seq)}></Checkbox>
                                  </Box>
                                  :
                                  <Box>
                                    <Box sx={{display:"flex", alignItems:"center",height:"20px",margin:"2px"}}>
                                      <Box>답변:</Box>
                                      <Checkbox style={{ color: '#27cc2f' }} checked={row.spk_gub == "A" ? true:false} onClick={(e:any)=> handleChangeQA('A',row.seq)}></Checkbox>
                                      {row.spk_gub == "A" &&
                                        ((kiStc && kiStc.length !== 0) && 
                                          <FormControl style={{width:"34px", fontSize:"12px"}} >
                                            <Select id="scriptState" value={row.sid} onChange={(e)=>{handleChangeSID(e.target.value, row.seq)}} sx={{width:"34px",height: "20px", border:"1px solid #498ad5", padding: "2px 0px 2px 4px", borderRadius:"4px", backgroundColor:"#d5ffd7"}}>
                                              <MenuItem dense value={''}>{''}</MenuItem>
                                              {kiStc.map((stc: any) => 
                                                <MenuItem dense key={stc.sid} value={stc.sid}>{stc.sid}</MenuItem>
                                              )}
                                            </Select>
                                          </FormControl>
                                        )
                                      }
                                    </Box>
                                    
                                  </Box>
                                }
                              </Box>
                              <Box sx={{marginLeft:"8px"}}>
                                <Box sx={{height: "10px", margin: "1px", fontSize:"11px" }}>
                                  <TextField
                                    InputProps={{
                                      style: {height: "14px", margin: "1px", fontSize:"11px", width: "110px",padding:"0" }
                                    }}
                                    inputProps={{
                                      style: { padding: "0", textAlign:"center" }
                                    }}
                                    value={row.start_time} 
                                    onChange={(e:any)=> handleChangeTime(e.target.value,'start_time', row.seq)}
                                    />
                                  {" --> "}
                                  <TextField 
                                    InputProps={{
                                      style: {height: "12px", margin: "1px", fontSize:"11px", width: "110px",padding:"0"  }
                                    }}
                                    inputProps={{
                                      style: { padding: "0", textAlign:"center" }
                                    }}
                                    value={row.end_time}
                                    onChange={(e:any)=> handleChangeTime(e.target.value,'end_time', row.seq)}
                                    />
                                <Button variant="contained" sx={{width:"12px", height:"14px", marginLeft:"8px", fontSize: "12px", backgroundColor:"#2cc382"}} onClick={()=>replayWave(row.start_time)}>REPLAY</Button></Box>
                                {/* <Box><textarea defaultValue={row.stt_con} onChange={(e:any)=> handleChangeStc_con(e.target.value, row.seq)} style={{width:"790px" ,marginTop:"2px", minHeight:"30px", fontSize:"12px", fontWeight:600, backgroundColor:(row.qa_flag === "" ? "#fff": (row.qa_flag === "Q" ? "#fbf4dd":"#d5ffd7"))}}  /></Box> */}
                                <Box><textarea defaultValue={row.stt_con} onChange={(e:any)=> handleChangeStt_con(e.target.value, row.seq)} style={{width:"500px" ,marginTop:"2px", minHeight:"40px", fontSize:"12px", fontWeight:600,padding:"2px", backgroundColor:((row.spk_gub === "Q" ? "#fbf4dd":(((row.spk_gub === "A" && row.sid !=="" && row.sid !=="None") ? "#d5ffd7":"#fff"))))}}  /></Box>
                              </Box>
                            </Box>
                            
                          </Box>
                        </Box>
                      </Box>

                      )
                    ):""
                  }
                </Paper>


              </Box>
            </Box>
            
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              setOpen(false);
            }}
          >
            취소
          </Button>
          {stopUpdate === false &&
          <><Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            // sampleReject();
            setRejectPageOpen(true);
          }}
        >
          부적합처리
        </Button>
        <Button variant="contained" color="warning" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            // sampleReject();
            setDelayPageOpen(true);
          }}
        >
          보류처리
        </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            // sampleConfirm();
            nvSttSrtConfirm();
          }}
        >
          검사완료
        </Button></>}
          
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default OrgDetailDialog;
